const chatScriptId = 'regionsChatScript';

const installChat = (runMode) => {
  const sysEnv = runMode === 'production' ? 'regions' : 'regionstest';

  const scriptElement = document.createElement('script');
  scriptElement.id = chatScriptId;
  scriptElement.src = `https://asset.gomoxie.solutions/concierge/${sysEnv}/client/concierge-client.js`;
  scriptElement.async = true;
  document.body.appendChild(scriptElement);
}

const uninstallChat = () => {
  const scriptElement = document.getElementById(chatScriptId);
  document.body.removeChild(scriptElement);
}

export {
  installChat,
  uninstallChat
}
